import React from "react";
import { Link, useNavigate } from "react-router-dom";
import type { ReactNode } from "react";
import { useCart } from "../hooks/useCart";
import {
  Header,
  Nav,
  Logo,
  NavLinks,
  NavLink,
  CartButton,
  CartCount,
  Container,
  Main,
} from "./styled";

interface LayoutProps {
  children: ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { getItemsCount } = useCart();
  const navigate = useNavigate();
  const itemsCount = getItemsCount();

  return (
    <>
      <Header>
        <Container>
          <Nav>
            <Link to="/" style={{ textDecoration: "none" }}>
              <Logo>ShopDemo</Logo>
            </Link>
            <NavLinks>
              <Link to="/" style={{ textDecoration: "none" }}>
                <NavLink as="span">Home</NavLink>
              </Link>
              <CartButton onClick={() => navigate("/cart")}>
                Cart
                {itemsCount > 0 && <CartCount>{itemsCount}</CartCount>}
              </CartButton>
            </NavLinks>
          </Nav>
        </Container>
      </Header>
      <Main>
        <Container>{children}</Container>
      </Main>
    </>
  );
};
